// @ts-nocheck
export const toggleAnimateCutoverLogo = (animate: boolean) => {
  const elm = document.getElementsByName('logo')[0]
  elm && elm.classList && (animate ? elm.classList.add('alive') : elm.classList.remove('alive'))
}
